import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl } from '@hvlng/framework-bff/core';
import { TimeConstrainedBaseQueryModel } from 'humanresources-common-shared';

@JsonObject('KovanHrOrganizationDefinitionQueryModel')
export class OrganizationDefinitionQueryModel extends TimeConstrainedBaseQueryModel {
    @EmptyControl()
    @JsonProperty('atLevel', Number, true)
    atLevel: number = null;

    @EmptyControl()
    @JsonProperty('onlyTopLevel', Boolean, true)
    onlyTopLevel: boolean = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionId', Number, true)
    perObjectDefinitionId: number = null;


    @EmptyControl()
    @JsonProperty('perObjectDefinitionUuid', String, true)
    perObjectDefinitionUuid: string = null;

    @EmptyControl()
    @JsonProperty('staffFullnessStatus', String, true)
    staffFullnessStatus: string = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionPId', Number, true)
    perObjectDefinitionPId: number = null;

    @EmptyControl()
    @JsonProperty('ownDefinitionId', Number, true)
    ownDefinitionId: number = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionText', String, true)
    perObjectDefinitionText: string = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionUnitCode', String, true)
    perObjectDefinitionUnitCode: string = null;

    @EmptyControl()
    @JsonProperty('provinceId', Number, true)
    provinceId: number = null;

    @EmptyControl()
    @JsonProperty('subprovinceId', Number, true)
    subprovinceId: number = null;

    @EmptyControl()
    @JsonProperty('topOrganizationUuid', String, true)
    topOrganizationUuid: string = null;

    @EmptyControl()
    @JsonProperty('topOrganizationId', Number, true)
    topOrganizationId: number = null;


    @EmptyControl()
    @JsonProperty('managerName', String, true)
    managerName: string = null;

    @EmptyControl()
    @JsonProperty('organizationTypeCode', String, true)
    organizationTypeCode: string = null;
}
